"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _media = _interopRequireDefault(require("lemon-db/dist/options/media.json"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var options = {
  size: _media["default"].size
};
var _default = options;
exports["default"] = _default;